import { n } from "./property-BWlAHqg_.js";
import "./query-assigned-elements-B8U94KLQ.js";
var c = Object.defineProperty, l = Object.getOwnPropertyDescriptor;
function m(p, { validSizes: h = ["s", "m", "l", "xl"], noDefaultSize: z, defaultSize: u = "m" } = {}) {
  class a extends p {
    constructor() {
      super(...arguments), this._size = u;
    }
    get size() {
      return this._size || u;
    }
    set size(e) {
      const s = z ? null : u, i = e && e.toLocaleLowerCase(), t = h.includes(i) ? i : s;
      if (t && this.setAttribute("size", t), this._size === t) return;
      const r = this._size;
      this._size = t, this.requestUpdate("size", r);
    }
    update(e) {
      !this.hasAttribute("size") && !z && this.setAttribute("size", this.size), super.update(e);
    }
  }
  return ((o, e, s) => {
    for (var i, t = l(e, s), r = o.length - 1; r >= 0; r--) (i = o[r]) && (t = i(e, s, t) || t);
    t && c(e, s, t);
  })([n({ type: String })], a.prototype, "size"), a;
}
export {
  m as S
};
//# sourceMappingURL=sizedMixin-B6C_XO64.js.map
